const accessCustomerFreelancerLink = {
    CUSTOMER_FREELANCER_LINK_LIST: { name: 'External Vendor', path: '/external-vendor-list' },
    ADD_CUSTOMER_FREELANCER_LINK: { name: 'Add External Vendor', path: '/add-external-vendor' },
    CUSTOMER_FREELANCER_LINK_DETAILS: { name: 'External Vendor Details', path: '/external-vendor-details' },
    DELETE_CUSTOMER_FREELANCER_LINK: { name: 'Delete External Vendor', path: '/delete-external-vendor' },
}

export default accessCustomerFreelancerLink;
